import store from '@/store'
export default [
  {
    path: '/exam-schedules',
    name: 'exam-schedule',
    meta: { requiresAuth: true },
    component: () => import('@/pages/exam-schedule/index.vue')
  },
  {
    path: '/exam-schedules/:id',
    name: 'exam-schedule-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/exam-schedule/index.vue'),
    props: route => ({ editData: route.params.editData }),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('examSchedule/dataBeforeCreate')
      let response = await store.dispatch('examSchedule/find', to.params.id)
      let { ...resource } = response.data
      to.params.editData = resource
      next()
    }
  }
]
